import { createContext } from "react";
import type { IMarkdownContext } from "./markdown.types";

/** Shared empty set so the common case — nothing has failed to load — never allocates or changes identity. */
export const NO_FAILED_IMAGE_SOURCES: ReadonlySet<string> = new Set<string>();

/**
 * Supplies the markdown element components with the properties the caller gave `Markdown`.
 *
 * They cannot close over those properties: `react-markdown` uses whatever is in its `components` map as the element
 * *type*, so a component recreated on each render is a new type on each render and React unmounts and remounts
 * everything it produced. For an `<img>` that means the browser re-requests the image every time the surrounding
 * message re-renders, and any state recording that the image already failed is thrown away with it. Keeping the
 * components module-level and passing their inputs through this context keeps the rendered elements in place.
 */
export const MarkdownContext = createContext<IMarkdownContext>({
    failedImageSources: NO_FAILED_IMAGE_SOURCES,
    reportImageFailure: () => undefined,
});
